import { getDomainConfig } from '@/utils/domainConfig'

/**
 * Minimal, non-promotional "go quiet" holding page shown on production hosts when
 * VITE_PUBLIC_QUIET === 'true'. No token marketing, no offer language, no whitepaper links.
 * Staging and localhost never render this (see isPublicQuietMode()).
 */
export function HoldingPage() {
  const isQSAVE = getDomainConfig().type === 'opensource'
  const name = isQSAVE ? 'QSAVE' : 'QKey'
  const tagline = isQSAVE
    ? 'Quantum Secure Asset Verification & Endowment'
    : 'Post-quantum wallet technology'
  const contact = isQSAVE ? 'hello@qsave.org' : 'hello@qkey.co'

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900 px-6 text-center">
      <div className="max-w-xl">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-3">{name}</h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">{tagline}</p>

        <p className="text-gray-600 dark:text-gray-300 mb-8">
          Our site is being updated. Public information will be available here soon.
        </p>

        <div className="text-sm text-gray-500 dark:text-gray-400 border-t border-gray-200 dark:border-gray-700 pt-6 space-y-2">
          <p>
            This page is informational only. It is not an offer, solicitation, or
            invitation to buy or sell any token, security, or financial instrument. {name} conducts
            no public token sale. Nothing here is investment, financial, legal, or tax advice.
          </p>
          <p>
            Enquiries:{' '}
            <a href={`mailto:${contact}`} className="text-quantum-600 hover:text-quantum-700">
              {contact}
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default HoldingPage
